<template>
    <div id="quizInfoPage" v-if="quiz != null" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="open" class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 m-auto">
                    <div class="header mb-2">
                        <h3 v-if="quiz.rewardingType == 'TRANSFER'" class="m-auto">{{ $t('trivia.quiz_info_transfer_title') }}</h3>
                        <h3 v-else class="m-auto">{{ $t('trivia.quiz_info_standard_title') }}</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>

                    <div class="d-flex justify-content-center mb-3">
                        <img v-if="quiz.rewardingType == 'TRANSFER'" src="/images/trivia/info-transfer.png" class="vh-15" />
                        <img v-else src="/images/trivia/info-standard.png" class="vh-15" />
                    </div>

                    <div v-if="quiz.rewardingType == 'TRANSFER'" class="text-justify mb-3" v-html="$t('trivia.quiz_info_transfer_text')"></div>
                    <div v-else class="text-justify mb-3" v-html="$t('trivia.quiz_info_standard_text')"></div>

                    <h4 class="text-orange text-center mb-3">{{ $t('trivia.quiz_info_motivation') }}</h4>
                    <div class="text-center"> 
                        <p v-if="quiz.rewardingType == 'TRANSFER'" v-html="$t('trivia.quiz_info_transfer_footer')"></p>
                        <p v-else v-html="$t('trivia.quiz_info_standard_footer')"></p>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

const TriviaQuizInfo = Vue.component('trivia-quiz-info', {
    data() {
        return {
            open: false
        }
    },
    computed: {
        quiz() {
          return this.$store.state.trivia.quiz;
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },  
    },
    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        }
    }
})

export default TriviaQuizInfo
</script>